function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26,14.93c0-.27-5.09-7-11-7a10.06,10.06,0,0,0-4.88,1.42L8,7.21l-.71.71,2,1.95A18.62,18.62,0,0,0,4,14.93c0,.27,5.09,7,11,7a10.06,10.06,0,0,0,4.88-1.42l2.27,2.27.71-.71L20.77,20A18.77,18.77,0,0,0,26,14.93ZM15,20.39c-4.27,0-8-4.07-9.13-5.46a19.12,19.12,0,0,1,4.46-4l1.31,1.32a4.27,4.27,0,0,0,6,6l1.12,1.13A8.49,8.49,0,0,1,15,20.39Zm4.67-1.5-1.32-1.32a4.23,4.23,0,0,0,.94-2.65A4.29,4.29,0,0,0,15,10.63a4.23,4.23,0,0,0-2.65.94l-1.12-1.12a8.49,8.49,0,0,1,3.77-1c4.27,0,8,4.07,9.13,5.46A19.12,19.12,0,0,1,19.67,18.89Z"
});

var SvgIconInvisble = function SvgIconInvisble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a8125f40-b585-4613-b66e-521f20023ad5",
    "data-name": "Icons",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInvisble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-invisble.2c3cbe2f.svg";
export { ForwardRef as ReactComponent };